export const facets = {
  "master_brand": "Brands",
  "master_category_tags": "Categories",
  "master_size_list": "Sizes",
  "distributors": "Vendors",
  "colors.name": "Colors",
}
